'use strict';
var ACC;
ACC.navigation = {

    _autoload: [
        'offcanvasNavigation',
        'myAccountNavigation',
        'bindTrackingEvents',
        ['listenForMobileMenuActivators', $('.mobile-second-level-cat-navigation button').length > 0],
        'bindGlobalHeaderTrackHelp'
    ],

    _const: {
        SELECTOR_MAIN_NAV: '.main-header .main-navigation .nav',
        SELECTOR_SUB_NAV: '.main-header .main-navigation .sub-navigation'
    },

    bindTrackingEvents: function () {
        if (ACC.mobilemenu.ready) {
            ACC.navigation.bindFlashEventsClick();
        } else {
            $(document).on('ACC.mobilemenu.ready', ACC.navigation.bindFlashEventsClick);
        }
    },

    bindFlashEventsClick: function () {
        $('#facetScroll li[data-categoryid="FlashEventsLink"] a, .mobilemenu [data-panel-link="FlashEventsLink"] a').on('click', function (e) {
            // ACC.gtm.trackPromotionClickGtmEvent('', '');
        });
    },

    offcanvasNavigation: function () {
        var screenSmMax = 1280;

        enquire.register('screen and (max-width:' + screenSmMax + 'px)', {
            match: function () {
                $('.header-search-input-box').show(); // Compensate in case we hid it in unmatch function.

                $(document).on('touchstart', '.js-enquire-offcanvas-navigation .js-enquire-has-sub > a', function (e) {
                    e.preventDefault();
                    $('.js-enquire-offcanvas-navigation > ul').addClass('active');
                    $('.js-enquire-offcanvas-navigation .js-enquire-has-sub').removeClass('active');
                    $(this).parent('.js-enquire-has-sub').addClass('active');
                    var thisTitle = $(this).attr('title');
                    $('.sm-back.js-enquire-sub-close span').html(thisTitle);
                });

                $(document).on('touchstart', '.js-enquire-offcanvas-navigation .sub-navigation-list a', function () {
                    var thisTitle = $(this).attr('title');
                    $('.sm-back.js-enquire-sub-close span').html(thisTitle);

                });

                $(document).on('touchstart', '.js-enquire-offcanvas-navigation .js-enquire-sub-close', function (e) {
                    e.preventDefault();
                    if ($('.sub-navigation-list').hasClass('active')) {
                        $('.js-enquire-offcanvas-navigation .sub-navigation').find('.row').removeClass('active');
                        $('.js-enquire-offcanvas-navigation .sub-navigation-list').removeClass('active');
                        var thisTitle = $('.js-enquire-has-sub.active a').attr('title');
                        $('.sm-back.js-enquire-sub-close span').html(thisTitle);
                    } else {
                        $('.js-enquire-offcanvas-navigation > ul').removeClass('active');
                        $('.js-enquire-offcanvas-navigation .js-enquire-has-sub').removeClass('active');
                    }
                });

                $(document).on('touchstart', '.js-enquire-offcanvas-navigation .title', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var thisTitle = $(this).text();
                    $('.sm-back.js-enquire-sub-close span').html(thisTitle);
                    var subNavSection = $(this).parents('.sub-navigation-section'),
                        subNavList = $(this).siblings('.sub-navigation-list'),
                        row = $(this).parents('.row'),
                        rowOffset = row.offset().top,
                        subNavOffset = subNavSection.offset().top,
                        offset = subNavOffset - rowOffset;

                    $(subNavList).addClass('active').css({
                        'top': '-' + offset + 'px'
                    });
                    $(row).addClass('active');
                });

                $(document).on('click', '.search-mask', function () {
                    ACC.global.toggleClassState($('main'), 'offcanvas');
                    $(this).hide();
                    $('#js-site-search-input').focus();
                    $('.searchbox').slideToggle();
                    $('.search-mask').toggleClass('nav-active');
                });
            },

            unmatch: function () {
                $('.js-enquire-offcanvas-navigation > ul').removeClass('active');
                $('.js-enquire-offcanvas-navigation .js-enquire-has-sub').removeClass('active');
                $(document).off('click', '.js-enquire-offcanvas-navigation .js-enquire-has-sub > a');
                $(document).off('click', '.js-enquire-offcanvas-navigation .js-enquire-sub-close');
                $(document).off('click', '.search-mask');
                $('.search-mask').removeClass('nav-active');
            }
        });
    },

    myAccountNavigation: function () {

        var oDoc = document;
        var aAcctData = [];
        var sSignBtn = '';
        var i;

        // My account items
        var oMyAccountData = $('.accNavComponent');

        // The my Account hook for the desktop
        var oMMainNavDesktop = $('.accNavComponentDesktop > ul');

        // Offcanvas menu for tablet /m obile
        var oMainNav = $('.main-navigation > ul.nav.nav-pills');

        if (oMyAccountData) {
            var aLinks = oMyAccountData.find('a');
            for (i = 0; i < aLinks.length; i++) {
                aAcctData.push({
                    link: aLinks[i].href,
                    text: aLinks[i].title
                });
            }
        }

        // Create Welcome User + expand / collapse
        var oUserInfo = $('.md-secondary-navigation ul li.logged_in');
        if (oUserInfo && oUserInfo.length === 1) {
            var sUserBtn = '<li class=\"auto hidden-md hidden-lg\"><div class=\"userGroup\">';
            sUserBtn += '<span class="glyphicon glyphicon-user myAcctUserIcon"></span><div class=\"userName\">' + oUserInfo[0].innerHTML + '</div>';
            if (aAcctData.length > 0) {
                sUserBtn += '<a class="collapsed" data-bs-toggle="collapse" data-bs-target=".offcanvasGroup1"><span class="glyphicon glyphicon-chevron-up myAcctExp"></span></a>';
            }
            sUserBtn += '</div></li>';
            $(sUserBtn).insertBefore($(oMainNav.children()[0]));
        }

        // Create a My Account Top link for desktop - in case more components come then more parameters need to be passed from the backend
        const myAccountHook = $('<a class="myAccountLinksHeader collapsed" data-bs-toggle="collapse" data-bs-target="#accNavComponentDesktop">' + oMyAccountData.data('title') + '</a>');
        myAccountHook.insertBefore(oMyAccountData);

        var oLink,
            oListItem;

        // Offcanvas items
        for (i = aAcctData.length - 1; i >= 0; i--) {
            oLink = oDoc.createElement('a');
            oLink.title = aAcctData[i].text;
            oLink.href = aAcctData[i].link;
            oLink.innerHTML = aAcctData[i].text;

            oListItem = oDoc.createElement('li');
            oListItem.appendChild(oLink);
            oListItem = $(oListItem);
            oListItem.addClass('auto offcanvasGroup1 offcanvasNoBorder hidden-md hidden-lg collapse show');
            oListItem.insertAfter($(oMainNav.children()[0]));
        }

        // Create Sign In / Sign Out Button
        if ($('.liOffcanvas a') && $('.liOffcanvas a').length > 0) {
            sSignBtn += '<li class=\"auto hidden-md hidden-lg liUserSign\" ><a class=\"userSign\" href=\"' + $('.liOffcanvas a')[0].href + '\">' + $('.liOffcanvas a')[0].innerHTML + '</a></li>';
            if (oUserInfo && oUserInfo.length === 1) {
                $(sSignBtn).insertAfter($(oMainNav.children()[aAcctData.length]));
            } else {
                $(sSignBtn).insertBefore($(oMainNav.children()[0]));
            }
        }

        // Desktop
        for (i = 0; i < aAcctData.length; i++) {
            oLink = oDoc.createElement('a');
            oLink.title = aAcctData[i].text;
            oLink.href = aAcctData[i].link;
            oLink.innerHTML = aAcctData[i].text;

            oListItem = oDoc.createElement('li');
            oListItem.appendChild(oLink);
            oListItem = $(oListItem);
            oListItem.addClass('auto col-md-4');
            oMMainNavDesktop.get(0).appendChild(oListItem.get(0));
        }

        // Collapsible logic for my account
        // Bootstrap 5's Collapse dispatches plain native events, so these must be
        // bound with `addEventListener` (jQuery's `.on()` never sees them).
        $('.offcanvasGroup1').each(function () {
            this.addEventListener('hidden.bs.collapse', function () {
                $('.offcanvasGroup1 a').hide();
                $('.userGroup span.myAcctExp').removeClass('glyphicon-chevron-down').addClass('glyphicon-chevron-up');
            });
            this.addEventListener('show.bs.collapse', function () {
                $('.offcanvasGroup1 a').show();
                $('.userGroup span.myAcctExp').removeClass('glyphicon-chevron-up').addClass('glyphicon-chevron-down');
            });
            window?.bootstrap?.Collapse.getOrCreateInstance(this, { toggle: false });
        });
        if (oUserInfo && oUserInfo.length === 1 && aAcctData.length > 0) {

            $('.userGroup').on('click', function () {
                var aCollapsibleElements = $('.offcanvasGroup1');
                if (aCollapsibleElements && $('.offcanvasGroup1').length > 0) {
                    if ($(aCollapsibleElements[0]).hasClass('show')) {
                        aCollapsibleElements.addClass('offcanvasNoBorder').removeClass('offcanvasBorderColor');
                        aCollapsibleElements.each(function () {
                            window?.bootstrap?.Collapse.getOrCreateInstance(this).hide();
                        });
                    } else {
                        aCollapsibleElements.each(function () {
                            window?.bootstrap?.Collapse.getOrCreateInstance(this).show();
                        });
                        aCollapsibleElements.removeClass('offcanvasNoBorder').addClass('offcanvasBorderColor');
                    }
                }
            });
        }
        // Collapsible logic for my account
    },

    listenForMobileMenuActivators: function () {
        enquire.register('screen and (max-width:768px)', {
            match: function () {
                $(document).on('click.mobileMenuActivator', '.mobile-second-level-cat-navigation button', function (e) {
                    var categoryid = this.getAttribute('data-categoryid');
                    if (categoryid) {
                        e.preventDefault();
                        ACC.mobilemenu.openAt(categoryid);
                    }
                });
            },
            unmatch: function () {
                $(document).off('click.mobileMenuActivator');
            }
        });
    },

    // Return cached main nav content.
    mainNav: function () {
        if (this._cache.$mainNav === undefined) {
            this._cache.$mainNav = $(this._const.SELECTOR_MAIN_NAV);
        }
        return this._cache.$mainNav;
    },

    bindGlobalHeaderTrackHelp: function () {
        $('.header-link.header-help-link > a').click(function() {
            window.ACC.gtm.trackGlobalHeaderIconClick($(this).attr('aria-label'));
        });


    }
};
